module.exports = __webpack_public_path__ + "static/media/ic-info.ac9358fd.svg";